import {axiosConfig} from '../api/axios-config.js'

// AI 對話審核
export const aiConversations = {
  // 取得對話列表
  get: (params, token) => axiosConfig.get('/api/ai/conversations', {
    params,
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 取得單筆對話詳情
  getById: (id, token) => axiosConfig.get(`/api/ai/conversations/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 取得群組列表
  getGroups: (token) => axiosConfig.get('/api/ai/conversations/groups', {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 取得統計資料
  getStatistics: (token) => axiosConfig.get('/api/ai/conversations/statistics', {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 審核對話
  review: (id, data, token) => axiosConfig.post(`/api/ai/conversations/${id}/review`, data, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 建立 FAQ
  createFaq: (id, data, token) => axiosConfig.post(`/api/ai/conversations/${id}/create-faq`, data, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 更新知識庫
  updateKnowledge: (id, data, token) => axiosConfig.post(`/api/ai/conversations/${id}/update-knowledge`, data, {
    headers: { Authorization: `Bearer ${token}` }
  })
}